import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { UserAddressEntity } from '../../domain/entities/UserAddressEntity'

export class UserAddressModel extends UserAddressEntity {
  constructor(dataDto: UserAddressEntity) {
    super()
    mapEntityProperties<UserAddressModel>(this, dataDto)
  }
}
